import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from "@amzn/stencil-react-components/modal";
import { H2 } from "@amzn/stencil-react-components/text";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export interface DisclaimerProps {
  close: () => void;
}

export const Disclaimer: FC<DisclaimerProps> = (props: DisclaimerProps) => {
  return (
    <ModalContainer>
      <ModalHeader>
        <H2>{getString("aiForMe.disclaimer")}</H2>
      </ModalHeader>
      <ModalBody>
        <img
          src="/img/aiforme-people-animated.svg"
          alt="Two people working using AI tools"
          style={{
            width: "100%",
            height: "auto",
          }}
          data-testid="people-img"
        />
        <Text>
          <p>{getString("aiForMe.followPolicy")}</p>
          <p>
            <a href="https://policy.a2z.com/docs/42682/publication#4.8.4" target="_blank" rel="noopener noreferrer">
              {getString("aiForMe.awsDataText")}
            </a>{" "}
            (AWS data)
          </p>
          <p>
            <a href="https://policy.a2z.com/docs/97/publication" target="_blank" rel="noopener noreferrer">
              {getString("aiForMe.dataClassificationStandard")}
            </a>{" "}
            (all other data)
          </p>
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button key="confirm" onClick={props.close} variant={ButtonVariant.Primary}>
          {getString("aiForMe.acknowledge")}
        </Button>
      </ModalFooter>
    </ModalContainer>
  );
};
